import type * as React from "react";
import { Component } from "react";

import { connect } from "react-redux";

import { showErrorToast, showSuccessToast } from "app/actions/toast_actions";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import { i18nFilter } from "app/filters/i18nFilter";
import { FavoritesService } from "app/services/favorites/favoritesService";
import { stateService } from "app/user-data/StateService";
import type { IStateObject } from "app/@types/userdata";

import { FaviconButton } from "./FaviconButton";
import { allTrackers } from "app/services/track/track";

interface IFaviconButtonContainerProps {
    duration: string;
    country: string;
    website: string;
    type: string;
    showSuccess?: any;
    showError?: any;
    hoverMessages?: any;
}

interface IFaviconButtonContainerState {
    isCurrentItemFavorite?: boolean;
}

class ButtonContainer extends Component<IFaviconButtonContainerProps, IFaviconButtonContainerState> {
    constructor(props) {
        super(props);
        this.state = {
            isCurrentItemFavorite: this.isCurrentItemFavorite(),
        };
    }

    public componentDidUpdate(prevProps) {
        if (prevProps.website !== this.props.website) {
            this.setState({
                ...this.state,
                isCurrentItemFavorite: this.isCurrentItemFavorite(),
            });
        }
    }

    private isCurrentItemFavorite = () => {
        const stateObj: IStateObject = {
            mainItem: this.props.website,
            type: "website",
        };
        return Boolean(FavoritesService.findFavorite(stateObj));
    };

    private addCurrentItemToFavorites = async () => {
        const state = await stateService.serializeState();
        // overwrite comparedItems, country, duration, and mainItem according to Product requirements
        state.comparedItems = [];
        state.country = +this.props.country;
        state.duration = "3m";
        state.mainItem = this.props.website;
        return FavoritesService.addFavorite(state);
    };

    private removeCurrentItemToFavorites = () => {
        const stateObj: IStateObject = {
            mainItem: this.props.website,
            type: "website",
        };
        const fav = FavoritesService.findFavorite(stateObj);
        return FavoritesService.removeFavoriteById(fav);
    };

    public render() {
        return (
            <FaviconButton
                isCurrentItemFavorite={this.state.isCurrentItemFavorite}
                hoverMessages={this.props.hoverMessages}
                onFavoriteClick={this.toggleFavoritesPage}
            />
        );
    }

    private toggleFavoritesPage = () => {
        const { addSuccessToastMessage, addErrorToastMessage, removeSuccessToastMessage, removeErrorToastMessage } =
            this.props.hoverMessages;
        const showSuccess = this.props.showSuccess;
        const showError = this.props.showError;
        this.trackFavoritesClickEvent();

        if (!this.state.isCurrentItemFavorite) {
            try {
                this.addCurrentItemToFavorites();
                this.setState({ isCurrentItemFavorite: true });
                showSuccess(i18nFilter()(addSuccessToastMessage));
            } catch (error) {
                this.setState({ isCurrentItemFavorite: false });
                showError(i18nFilter()(addErrorToastMessage));
            }
        } else {
            try {
                this.removeCurrentItemToFavorites();
                this.setState({ isCurrentItemFavorite: false });
                showSuccess(i18nFilter()(removeSuccessToastMessage));
            } catch (error) {
                this.setState({ isCurrentItemFavorite: true });
                showError(i18nFilter()(removeErrorToastMessage));
            }
        }
    };

    private trackFavoritesClickEvent = () => {
        const isItemFavorite = this.isCurrentItemFavorite();
        if (isItemFavorite) {
            allTrackers.dispatchTrackEvent(
                "Button",
                "click",
                `Remove Site/QualificationSidebar/${this.props.website || ""}`,
            );
        } else {
            allTrackers.dispatchTrackEvent(
                "Button",
                "click",
                `Add Site/QualificationSidebar/${this.props.website || ""}`,
            );
        }
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        showSuccess: (text?: string, linkText?: string, href?: string) =>
            dispatch(
                showSuccessToast(
                    getToastItemComponent({
                        text,
                        linkText,
                        href,
                    }),
                ),
            ),
        showError: (text?: string) => dispatch(showErrorToast(text)),
    };
};

export const FaviconButtonContainer = connect(
    undefined,
    mapDispatchToProps,
)(ButtonContainer as React.ComponentType<any>);
